import { render } from "./DeLeche.vue?vue&type=template&id=2e861804"
import script from "./DeLeche.vue?vue&type=script&lang=js"
export * from "./DeLeche.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/Devolucion/DeLeche.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e861804"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e861804', __exports__)) {
    api.reload('2e861804', __exports__)
  }
  
  module.hot.accept("./DeLeche.vue?vue&type=template&id=2e861804", () => {
    api.rerender('2e861804', render)
  })

}


export default __exports__